import { css } from '@emotion/react';
import { COLORS3 } from '@zola/zola-ui/src/styles/emotion';

export const borderTop = css`
  border-top: 1px solid ${COLORS3.BLACK_030};
`;
